import { Button, Typography, Divider } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import ColorHelper from "../../Helpers/ColorHelper";
import ConstantHelper from "../../Helpers/ConstantHelper";
import FontHelper from "../../Helpers/FontHelper";
import IconHelper from "../../Helpers/IconHelper";

import {
  addAllToCart,
  clearCart,
  fetchProducts,
} from "../../redux/shoppingActions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import { useEffect } from "react";
import axios from "axios";
import { ApiManager } from "../../ApiClient";
import { useSnackbar } from "notistack";
import Loading from "../../Components/Loader/Loading";
import "../../App.css";

const SummarySection = ({
  imagesCount,
  orderId,
  bibNumber,
  eventName,
  ReportBtn,
  unlabledPage,
  type,
  price,
  count,
  urls,
  reportPics,
  reportPicsHandle,
  reportedPhoto,
  setReportedPhoto,
  disabled,
  logo,
}) => {
  const dispatch = useDispatch();
  const [addAllToCartText, setAddAllToCart] = React.useState("Add all to cart");
  const cartInfo = useSelector((state) => state.shop.cartInfo);
  const { eventId } = useSelector((state) => state.shop.products);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 980);

  const [isLoading, setIsLoading] = useState(false);
  const [showCertificateButton, setShowCertificateButton] = useState(false);

  const filteredCart = cartInfo.filter((item) => {
    if (item.type === "download") {
      return item.category !== "image";
    }
    return item;
  });
  const products = useSelector((state) => state.shop.products);
  const location = useLocation();
  const navigate = useNavigate();
  const findpath = location.pathname;
  const config = useSelector((state) => state.config.masterConfig.result);
  const collage = cartInfo?.filter((items) => items.type == "collage");
  const print = cartInfo?.filter((items) => items.type == "print");
  const images = cartInfo?.filter(
    (items) => items.type === "download" && items.category === "image"
  );
  const videos = cartInfo?.filter(
    (items) => items.type === "download" && items.category === "video"
  );

  let isPending = "false";
  if (findpath === "/myorders" || findpath === "/preauthdownload") {
    isPending = "false";
  } else {
    isPending = localStorage?.getItem("isPending");
  }
  let isSignedIn = localStorage?.getItem("isSignedIn");
  const snack = useSnackbar();

  // Check certificate eligibility on mount and when relevant data changes
  useEffect(() => {
    checkCertificateEligibility();
  }, []);

  const checkCertificateEligibility = () => {
    try {
      const achievementsData = localStorage.getItem("achievementsEligibility");
      if (achievementsData) {
        const achievement = JSON.parse(achievementsData);
        const ShowCertificateGeneratebtn =
          achievement.certificate_eligible === true &&
          (achievement.certificate_url === '' || achievement.certificate_url === 'null' || achievement.certificate_url === null);

        // Testing new condition to show button
        // const ShowCertificateGeneratebtn =
        //   achievement.certificate_eligible === true ||
        //   achievement.certificate_url !== '';
        setShowCertificateButton(ShowCertificateGeneratebtn);
      } else {
        setShowCertificateButton(false);
      }
    } catch (error) {
      console.error("Error parsing achievements eligibility:", error);
      setShowCertificateButton(false);
    }
  };

  const handleAllToCart = () => {
    if (
      new Date().getTime() >
      new Date(localStorage?.getItem("awsImageExpiry")).getTime()
    ) {
      navigate("/home");
    } else {
      if (addAllToCartText == "Add all to cart") {
        dispatch(addAllToCart(products.photo, bibNumber, filteredCart));
        setAddAllToCart("EMPTY CART");
      } else {
        dispatch(clearCart());
        setAddAllToCart("Add all to cart");
      }
    }
  };

  const downloadPackage = async () => {
    setIsLoading(true);
    const response = await axios.post(ApiManager.downloadOrderZip(), {
      orderID: orderId,
      bibNumber: bibNumber,
    });
    if (response.data.StatusCode == 200) {
      setIsLoading(false);
      const link = document.createElement('a');
      link.href = response.data.result;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const checkFullPackage = () => {
    const downloads = cartInfo?.filter((items) => items.type == "download");
    if (products?.photo?.length == downloads?.length) {
      setAddAllToCart("EMPTY CART");
    }
  };

  const hidePhotoHandler = async (type) => {
    let response = {};
    if (reportedPhoto.length > 0) {
      response = await axios.post(ApiManager.recordFeedbackOnImage(), {
        usrfeedback: type === "hide" ? 1 : 2,
        bibNumber: bibNumber,
        photoids: reportedPhoto.join(),
      });
    } else {
      snack.enqueueSnackbar({
        variant: "warning",
        message: "Select atleast one photo.",
      });
    }

    if (response?.status === 200) {
      dispatch(
        fetchProducts(
          localStorage.getItem("Selected Event"),
          bibNumber,
          eventId
        )
      );
      reportPicsHandle();
      setReportedPhoto([]);
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 980);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    checkFullPackage();
  }, []);

  return (
    <Box>
      <div style={{ display: isLoading ? "flex" : "none" }} className="modal">
        <div className="modal-content">
          <div className="loader"></div>
          <div className="modal-text">Please Wait...</div>
        </div>
      </div>
      <>
        <Box
          sx={{
            px: { xs: 5, md: 5, lg: 10 },
            backgroundColor: ColorHelper.WhiteColor2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: {
                xs: "column",
                sm: "row",
                xxs: "row",
                md: "row",
                lg: "row",
              },
              alignItems: "center",
              minHeight: "auto",
              pt: 3,
              pb: 0.5,
              borderBottom: `1px solid ${ColorHelper.borderColor}`,
            }}
          >
            <Typography
              sx={{
                fontFamily: FontHelper.fBold,
                overflow: "hidden",
                whiteSpace: "wrap",
                height: "auto",
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                alignItems: "center",
                color: ColorHelper.BlueColor,
                mb: { xs: 2, md: 0 },
                pr: { xs: 0, sm: 3 },
                ...(unlabledPage == "true" && { pb: 2 }),
              }}
            >
              {logo ? (
                <img
                  src={logo}
                  alt="event_logo"
                  style={{ width: "66px", paddingRight: "6px" }}
                />
              ) : (
                ""
              )}
              {type !== "orderDetails" ? (
                <span
                  style={{
                    color: ColorHelper.BlackColor,
                    fontFamily: FontHelper.fMedium,
                  }}
                >
                  BIB No. :
                  <span
                    style={{
                      color: ColorHelper.BlueColor,
                      fontFamily: FontHelper.fBold,
                      marginLeft: "5px",
                    }}
                  >
                    {bibNumber}
                  </span>
                  <span
                    style={{
                      marginLeft: "5px",
                      marginRight: "5px",
                      color: ColorHelper.LightYellow2,
                    }}
                  >
                    |
                  </span>
                  {findpath !== "/cart" &&
                    findpath !== "/unlabeled-cart" &&
                    findpath !== "/unlabeled-events" ? (
                    <span
                      span
                      style={{
                        color: ColorHelper.BlueColor,
                        fontFamily: FontHelper.fBold,
                        margin: isMobileView ? "0" : "0 4px",
                        display: isMobileView ? "block" : "inline",
                        fontSize: 16,
                      }}
                    >
                      {`Congratulations.There are ${imagesCount} photos in this section.`}
                    </span>
                  ) : (
                    findpath === "/unlabeled-events" && (
                      <span
                        span
                        style={{
                          color: ColorHelper.BlueColor,
                          fontFamily: FontHelper.fBold,
                          margin: "0 4px",
                          fontSize: 16,
                        }}
                      >
                        {`There are ${imagesCount} photos in this section.`}
                      </span>
                    )
                  )}
                  {images?.length !== 0 &&
                    (findpath === "/cart" ||
                      findpath === "/unlabeled-cart") && (
                      <>
                        <span
                          style={{
                            color: ColorHelper.BlueColor,
                            fontFamily: FontHelper.fBold,
                            marginLeft: 4,
                            marginRight: 4,
                          }}
                        >
                          {images?.length}{" "}
                        </span>{" "}
                        {ConstantHelper.products1}{" "}
                      </>
                    )}
                  {videos?.length !== 0 &&
                    (findpath === "/cart" ||
                      findpath === "/unlabeled-cart") && (
                      <>
                        <span
                          style={{
                            color: ColorHelper.BlueColor,
                            fontFamily: FontHelper.fBold,
                            marginLeft: 4,
                            marginRight: 4,
                          }}
                        >
                          {videos?.length}{" "}
                        </span>{" "}
                        {ConstantHelper.products5}{" "}
                      </>
                    )}
                  {!config.DISABLEPRINTS.includes(products.eventId) &&
                    print?.length !== 0 &&
                    (findpath === "/cart" ||
                      findpath === "/unlabeled-cart") && (
                      <>
                        <span
                          style={{
                            color: ColorHelper.BlueColor,
                            fontFamily: FontHelper.fBold,
                            marginLeft: 4,
                            marginRight: 4,
                          }}
                        >
                          {" "}
                          {print?.length}{" "}
                        </span>{" "}
                        {ConstantHelper.products2}
                      </>
                    )}
                  {collage?.length !== 0 &&
                    (findpath === "/cart" ||
                      findpath === "/unlabeled-cart") && (
                      <>
                        <span
                          style={{
                            color: ColorHelper.BlueColor,
                            fontFamily: FontHelper.fBold,
                            marginLeft: 4,
                            marginRight: 4,
                          }}
                        >
                          {" "}
                          {collage?.length}{" "}
                        </span>{" "}
                        {ConstantHelper.products4}
                      </>
                    )}
                </span>
              ) : (
                <span
                  style={{
                    color: ColorHelper.BlackColor,
                    fontFamily: FontHelper.fMedium,
                  }}
                >
                  BIB No. :
                  <span
                    style={{
                      color: ColorHelper.BlueColor,
                      fontFamily: FontHelper.fBold,
                      marginLeft: "5px",
                    }}
                  >
                    {bibNumber}
                  </span>
                  <span
                    style={{
                      marginLeft: "5px",
                      marginRight: "5px",
                      color: ColorHelper.LightYellow2,
                    }}
                  >
                    |
                  </span>
                  <span style={{ color: "#667085", marginRight: 4 }}>
                    {"Order ID:"}
                  </span>
                  <span style={{ color: "#667085", marginRight: 4 }}>
                    {orderId}
                  </span>
                  <span
                    style={{
                      marginLeft: "5px",
                      marginRight: "5px",
                      color: ColorHelper.LightYellow2,
                    }}
                  >
                    |
                  </span>
                  <span style={{ color: "#667085", marginRight: 4 }}>
                    {"Order Total:"}
                  </span>
                  <span style={{ color: "#667085", marginRight: 4 }}>
                    ₹{price}
                  </span>
                </span>
              )}
            </Typography>

            {/* Report Pictures button */}
            {ReportBtn && reportPics == false && (
              <Box
                sx={{
                  mt: 1,
                  mb: 1,
                  mr: 2,
                  color: ColorHelper.YellowColor2,
                  fontSize: 16,
                  fontFamily: FontHelper.fMedium,
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  flexWrap: "nowrap",
                  gap: 1,
                  cursor: "pointer",
                  "&:hover": {
                    color: ColorHelper.PrimaryColor,
                    path: {
                      fill: ColorHelper.PrimaryColor,
                    },
                  },
                }}
                onClick={() =>
                  isSignedIn
                    ? reportPicsHandle()
                    : alert("you must log in to perform this action")
                }
              >
                {/* <IconHelper.WarningIcon /> Report picture(s) */}
                <IconHelper.WarningIcon />
                <span style={{ whiteSpace: "nowrap" }}>Report picture(s)</span>
              </Box>
            )}

            {ReportBtn && reportPics == true && (
              <Box
                sx={{
                  mt: 1,
                  color: ColorHelper.YellowColor2,
                  fontSize: 16,
                  fontFamily: FontHelper.fMedium,
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                  gap: 1,
                  cursor: "pointer",
                  "&:hover": {
                    color: ColorHelper.PrimaryColor,
                  },
                }}
                onClick={() =>
                  isSignedIn
                    ? reportPicsHandle()
                    : alert("you must log in to perform this action")
                }
              >
                {/* <IconHelper.LeftArrow /> Back */}
                <IconHelper.LeftArrow />
                <span style={{ whiteSpace: "nowrap" }}>Back</span>

              </Box>
            )}

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 3.5,
              }}
            >
              {(findpath == "/orderDetails" ||
                findpath == "/myorders" ||
                findpath == "/preauthdownload") &&
                isPending === "false" &&
                count !== 0 && (
                  <Button
                    onClick={downloadPackage}
                    disableripple={true}
                    sx={{
                      fontSize: 16,
                      backgroundColor: "#12B76A",
                      px: { xs: 2, md: 2 },
                      py: { xs: 1.5, md: 1.5 },
                      borderRadius: "3px",
                      marginLeft: "auto",
                      minWidth: "max-content",
                      mb: 0,
                      color: ColorHelper.WhiteColor,
                      backgroundColor: ColorHelper.PrimaryColor,
                      "&:hover": {
                        backgroundColor: ColorHelper.WhiteColor,
                        color: ColorHelper.PrimaryColor,
                        border: `1px solid ${ColorHelper.PrimaryColor}`,
                      },
                    }}
                  >
                    <DownloadIcon />
                    <span
                      style={{ paddingLeft: "10px" }}
                    >{`Download Full Package(${count})`}</span>
                  </Button>
                )}
              {(unlabledPage === "true" || type == "orderDetails"
                ? null
                : reportPics == false) &&
                (findpath === "/products" || findpath === "/searchbyselfie") ? (
                <Box
                  sx={{
                    display: "flex",
                    gap: { xs: 0.5, sm: 1, md: 2 },
                    flexWrap: "nowrap",
                    alignItems: "center",
                    justifyContent: { xs: "center", sm: "flex-start" },
                  }}
                >
                  {/* Conditionally render Event Certificate button */}
                  {showCertificateButton && (
                    <Button
                      // onClick={() => navigate("/eventcertificate")}
                      onClick={() => navigate("/eventcertificate", {
                        state: { eventName, bibNumber }
                      })}
                      disableRipple
                      sx={{
                        fontFamily: FontHelper.fBold,
                        fontSize: { xs: 12, sm: 14, md: 15 },
                        color: "#3F0E77",
                        backgroundColor: "transparent",
                        border: "1px solid #3F0E77",
                        px: { xs: 1, sm: 1.5, md: 2 },
                        py: { xs: 0.5, sm: 1, md: 1.5 },
                        borderRadius: "5px",
                        minWidth: { xs: "auto", sm: "max-content" },
                        mb: 0,
                        transition: "all 0.3s ease",
                        "&:hover": {
                          backgroundColor: "#3F0E77",
                          color: ColorHelper.WhiteColor,
                          borderColor: "#3F0E77",
                        },
                        "@media (max-width: 430px) and (max-height: 599px)": {
                          fontSize: "10px",
                          px: 0.8,
                          py: 0.4,
                        },
                        "@media (max-width: 391px) and (max-height: 599px)": {
                          fontSize: "9px",
                          px: 0.6,
                          py: 0.35,
                        },
                      }}
                    >
                      <span>Create Digital Frame</span>
                    </Button>
                  )}
                  <Button
                    onClick={handleAllToCart}
                    disableRipple
                    sx={{
                      fontFamily: FontHelper.fBold,
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: ColorHelper.WhiteColor,
                      backgroundColor: ColorHelper.IntenseBlue,
                      px: { xs: 1, sm: 1.5, md: 2 },
                      py: { xs: 0.5, sm: 1, md: 1.5 },
                      borderRadius: 0,
                      minWidth: { xs: "auto", sm: "max-content" },
                      mb: 0,
                      display: "flex",
                      alignItems: "center",
                      "&:hover": {
                        backgroundColor: ColorHelper.PrimaryColor,
                      },
                      "@media (max-width: 430px) and (max-height: 599px)": {
                        fontSize: "10px",
                        px: 0.8,
                        py: 0.4,
                      },
                      "@media (max-width: 391px) and (max-height: 599px)": {
                        fontSize: "9px",
                        px: 0.6,
                        py: 0.35,
                      },
                    }}
                  >
                    {new Date().getTime() >
                      new Date(
                        localStorage?.getItem("awsImageExpiry")
                      ).getTime() ? (
                      <></>
                    ) : (
                      <IconHelper.CartPlusIcon />
                    )}
                    <span
                      style={{
                        paddingLeft:
                          new Date().getTime() >
                            new Date(
                              localStorage?.getItem("awsImageExpiry")
                            ).getTime()
                            ? "0px"
                            : "10px",
                      }}
                    >
                      {new Date().getTime() >
                        new Date(
                          localStorage?.getItem("awsImageExpiry")
                        ).getTime()
                        ? "Home"
                        : addAllToCartText}
                    </span>
                  </Button>
                </Box>
              ) : findpath === "/products" ? (
                <div style={{ display: "flex", columnGap: 8 }}>
                  <Button
                    onClick={() => {
                      hidePhotoHandler("hide");
                    }}
                    disableripple={true}
                    sx={{
                      fontFamily: FontHelper.fBold,
                      fontSize: 16,
                      color: ColorHelper.ErrorText,
                      backgroundColor: ColorHelper.ErrorBg,
                      textTransform: "none",
                      px: { xs: 3, md: 3 },
                      py: { xs: 1, md: 1 },
                      borderRadius: 0,
                      marginLeft: "auto",
                      minWidth: "max-content",
                      borderRadius: 999,
                      mb: 0,
                      "&:hover": {
                        backgroundColor: ColorHelper.ErrorText,
                        color: ColorHelper.ErrorBg,
                      },
                    }}
                  >
                    <span>Hide</span>
                  </Button>
                  <Button
                    onClick={() => {
                      hidePhotoHandler("notMe");
                    }}
                    disableripple={true}
                    sx={{
                      fontFamily: FontHelper.fBold,
                      fontSize: 16,
                      color: ColorHelper.ErrorText,
                      backgroundColor: ColorHelper.ErrorBg,
                      textTransform: "none",
                      px: { xs: 3, md: 3 },
                      py: { xs: 1, md: 1 },
                      borderRadius: 0,
                      marginLeft: "auto",
                      minWidth: "max-content",
                      borderRadius: 999,
                      mb: 0,
                      "&:hover": {
                        backgroundColor: ColorHelper.ErrorText,
                        color: ColorHelper.ErrorBg,
                      },
                    }}
                  >
                    <span>Not Me</span>
                  </Button>
                </div>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Box>
      </>
    </Box>
  );
};

export default SummarySection;